import { makeEntityScaffold } from '@classpass/saga-tools';
export var getCountries = makeEntityScaffold('SAGA.API.GET_COUNTRIES', function (client) {
  return client.countries.get().then(function (data) {
    return data.countries;
  });
});